import { createFileRoute } from '@tanstack/react-router'
import { fetchConsultant } from '@/services/api/consultantsClient.ts'
import { ConsultantPage } from '@/pages/ConsultantPage.tsx'
import { ROUTES } from '@/constants/routeConstants.ts'

export const Route = createFileRoute(ROUTES.CONSULTANT_DETAIL)({
  loader: async ({ params }) => {
    try {
      const consultant = await fetchConsultant(Number(params.consultantId))

      return { consultant, error: null }
    } catch (error) {
      return { consultant: null, error }
    }
  },
  component: ConsultantPage,
})
